{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licence Number",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee",
      "isShownByDefault": true,
    },
  },
  "confidential_release_date": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Release Date",
      "width": 98,
      "isShownByDefault": true,
    },
  },
  "oil_production_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "Oil",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "c5_cond_production_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "Condensate",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "gas_production_mcf_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mcf/d",
    },
    "ui": {
      "label": "Gas",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "c2c3c4_production_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "NGL",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "formations": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formations",
      "isShownByDefault": true,
    },
  },
  "fields": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field",
      "isShownByDefault": true,
    },
  },
  "production_hours": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Producing Hours",
      "isShownByDefault": true,
    },
  },
  "on_prod_date": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "On Prod",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "cumulative_oil_volume_bbl": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl",
    },
    "ui": {
      "label": "Oil Cumulative",
      "isShownByDefault": true,
    },
  },
}
